// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"dc08bd4a","85":"b3298491","112":"af7da409","211":"a681a5d6","234":"a681a5d6","298":"ed2fdac9","543":"d6d602cc","603":"656ef9fe","962":"a681a5d6"}[chunkId] + ".chunk.css";
};